import React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { openPopup2 } from '../../../contexts/PopupContext';
import { selectPlan } from '../../../pages/PlanOperationPage/constants';
import { planOpActions } from '../../../pages/PlanOperationPage/reducer';
import { InfoMode, OP_STATUS, zIndex } from '../../../util/varibles/constants';
import { IOperation, IOperation2 } from "../../../util/varibles/interface";
import Info from "./Info";
import { PopupOpInfoProvider } from './PopupOpInfoContext';

interface IPropsOp {
    isOwn?: boolean
    isEdit?: boolean
    data: IOperation
    spOps?: IOperation[]

    onClose?(): void
}

export const openOpInfo = (props: IPropsOp) => {
    return openPopup2(<OpInfo {...props} />, {
        modalProps: {
            width: 900,
            zIndex: zIndex.popupLev1,
            mask: { closable: true, enabled: false }
        }
    })
}

const OpInfo: React.FC<IPropsOp> = (props) => {
    const { isEdit = true, data, isOwn = true, onClose } = props;
    const files = useSelector(selectPlan.files) || {};
    const { status, id } = data.operation;
    const dispatch = useDispatch();

    let isApprove = false;

    if (files[id])
        data.operation.files = [...files[id]];

    if (!isOwn && [OP_STATUS.PENDING, OP_STATUS.SAVED].indexOf(status) !== -1)
        isApprove = true;

    return <PopupOpInfo {...{
        isEdit,
        isOwn,
        isApprove,
        data,
        onClose,
        updateOperation: ({ data, isCheck }: { data: IOperation, isCheck: boolean }) => {
            dispatch(planOpActions.updateOps({ update: { [data.operation.id]: data }, isCheck }));
        },
    }} />
}

interface IProps extends IPropsOp {
    isOwn: boolean
    isApprove: boolean

    updateOperation(payload: { data: IOperation, isCheck?: boolean }): void

    onClose?(): void
}

const PopupOpInfo: React.FC<IProps> = (props) => {
    const { isEdit, isOwn, isApprove, data, updateOperation, onClose } = props;

    return <PopupOpInfoProvider
        data={data}
        infoMode={data.operation.status === OP_STATUS.FINISHED
            ? InfoMode.ACTUAL
            : InfoMode.PLAN}
        isOwn={isOwn}
        isEdit={isEdit && isOwn}
        isApprove={isApprove}
        onClose={onClose}
        updateOperation={updateOperation}
    >
        <div id='popup-operation-info' style={{ padding: '0 1px' }}>
            <Info
                data={data as IOperation2}
                isEdit={isEdit && isOwn}
                isApprove={isApprove}
            />
        </div>
    </PopupOpInfoProvider>
};

export default PopupOpInfo;
